var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOrganization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 68
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12-30h120V90H-12z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M36.643 0v21.818H19v5.455H0V60h76V27.273H57v-5.455H39.357V0h-2.714zM21.714 24.545h32.572v32.728H21.714V24.545zM2.714 30H19v27.273H2.714V30zM57 30h16.286v27.273H57V30z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M38 2.222h12.294l-4 4.314 4 4.575H38z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M32 58h12.294V42H32z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 3,
    transform: "translate(64 30)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#042B75"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M18 12v12m6-6H12"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDIiIGhlaWdodD0iNjgiIHZpZXdCb3g9IjAgMCAxMDIgNjgiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNLTEyLTMwaDEyMFY5MEgtMTJ6Ii8+CiAgICAgICAgPGcgb3BhY2l0eT0iLjciPgogICAgICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0zNi42NDMgMHYyMS44MThIMTl2NS40NTVIMFY2MGg3NlYyNy4yNzNINTd2LTUuNDU1SDM5LjM1N1YwaC0yLjcxNHpNMjEuNzE0IDI0LjU0NWgzMi41NzJ2MzIuNzI4SDIxLjcxNFYyNC41NDV6TTIuNzE0IDMwSDE5djI3LjI3M0gyLjcxNFYzMHpNNTcgMzBoMTYuMjg2djI3LjI3M0g1N1YzMHoiLz4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0zOCAyLjIyMmgxMi4yOTRsLTQgNC4zMTQgNCA0LjU3NUgzOHoiLz4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjMiIGQ9Ik0zMiA1OGgxMi4yOTRWNDJIMzJ6Ii8+CiAgICAgICAgPC9nPgogICAgICAgIDxnIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NCAzMCkiPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjE4IiByPSIxOCIgZmlsbD0iIzA0MkI3NSIvPgogICAgICAgICAgICA8cGF0aCBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBkPSJNMTggMTJ2MTJNMjQgMThIMTIiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgAddOrganization as ReactComponent };